<!-- <h2 mat-dialog-title *ngIf="showTests" translate style="margin: 0px">Automated Tests</h2>-->
<h2 mat-dialog-title *ngIf="showTestSteps && !test.IsSubTestOnly" translate style="margin: 0px">{{test.TestName}} -
    Steps</h2>
<h2 mat-dialog-title *ngIf="showTestSteps && test.IsSubTestOnly" translate style="margin: 0px">{{test.TestName}} - Steps
    (Shared Test)</h2>
<!-- <page-header *ngIf="showTestSteps && test.IsSubTestOnly" pageTitle="test.TestName + '- Steps' (Shared Test)"></page-header> -->
<a style="padding: 3px;" *ngIf="showTests"
    href="https://automationresults.tylertech.com/prod/tylerassurance/progress-overview?Id=MTg%3D" target="_blank"> Test
    Results </a>

<div *ngIf="showTests" style="display:flex; flex-direction:row; flex-grow:1; overflow:hidden;">
    <div style="display:flex; flex-direction:column; flex:1; overflow:hidden;">
        <tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
            <div class="flex-header">
                <!-- <page-header *ngIf="type!='InterventionEventDialog'"></page-header>
                <page-header *ngIf="type=='InterventionEventDialog'" pageTitle='Associate Behavior Events'> -->
                <page-header *ngIf="showTests" pageTitle="Automated Tests"></page-header>
                <page-header *ngIf="showTestSteps && !test.IsSubTestOnly" pageTitle="test.TestName + '- Steps'">
                </page-header>
            </div>
            <div class="flex-content">
                <div style="flex:1;overflow:auto;">
                    <mat-table #table [dataSource]="dataSource" multiTemplateDataRows matSortDisableClear matSort
                        [ngStyle]="{'min-width': V10 === true ? '1420px': ''}" id="ASTTable" matSortActive="TestOrder"
                        matSortDirection="desc" aria-label="Automated Testing Table">
                        <ng-container matColumnDef="TestAreaName">
                            <mat-header-cell style=" padding-right: 42px;" *matHeaderCellDef
                                mat-sort-header="TestAreaName">
                                Module
                                <!-- THIS IS REALLY AREA -->
                                <filter *ngIf="dataSource != null && dataSource != undefined" [data]="dataSource"
                                    columnName="TestAreaName" dataType="string" id="areaNameFilter" class="mat-filter">
                                </filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.TestAreaName}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="TestSubAreaName">
                            <mat-header-cell style="padding-right: 42px" *matHeaderCellDef
                                mat-sort-header="TestSubAreaName">
                                Portal
                                <!-- THIS IS REALLY SUB-AREA -->
                                <filter *ngIf="dataSource != null && dataSource != undefined" [data]="dataSource"
                                    columnName="TestSubAreaName" dataType="string" id="subAreaNameFilter"
                                    class="mat-filter">
                                </filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.TestSubAreaName}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="TestName">
                            <mat-header-cell style="padding-right: 42px;" *matHeaderCellDef mat-sort-header="TestName">
                                Test Name
                                <filter *ngIf="dataSource != null && dataSource != undefined" [data]="dataSource"
                                    columnName="TestName" dataType="string" id="testNameFilter" class="mat-filter">
                                </filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element">{{element.TestName}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="IsSubTestOnly">
                            <mat-header-cell id="SharedTest" *matHeaderCellDef mat-sort-header>
                                Shared Test
                                <filter *ngIf="dataSource != null && dataSource != undefined" class="mat-filter"
                                    [data]="dataSource" columnName="IsSubTestOnly" dataType="boolean">
                                </filter>
                            </mat-header-cell>
                            <mat-cell id="SharedTest" *matCellDef="let element">{{element.IsSubTestOnly ? 'Y' : ''}}
                            </mat-cell>
                        </ng-container>
                        <!-- <ng-container matColumnDef="Approved">
                            <mat-header-cell id="Approved"*matHeaderCellDef mat-sort-header>
                                Approved
                                <filter *ngIf="dataSource != null && dataSource != undefined" class="mat-filter" [data]="dataSource" columnName="Approved" dataType="boolean">
                                </filter>
                            </mat-header-cell>
                            <mat-cell id="Approved" *matCellDef="let element">{{element.Approved ? 'Y' : ''}}</mat-cell>
                        </ng-container> -->

                        <ng-container matColumnDef="TestStatus">
                            <mat-header-cell id="TestStatus" *matHeaderCellDef mat-sort-header="TestStatus">
                                Status
                                <filter *ngIf="dataSource != null && dataSource != undefined" class="mat-filter"
                                    [data]="dataSource" columnName="TestStatus" dataType="string">
                                </filter>
                            </mat-header-cell>
                            <mat-cell id="TestStatus" *matCellDef="let element">
                                {{element.InProgress ? 'In Progress' : ''}}
                                {{element.Approved ? 'Approved' : ''}}
                                {{element.IsObsolete ? 'Obsolete' : ''}}
                                {{element.ReadyForReview ? 'Ready for Review' : ''}}
                            </mat-cell>
                        </ng-container>

                        <!-- <mat-option [value]="0">In Progress</mat-option>
                        <mat-option [value]="1">Ready for Review</mat-option>
                        <mat-option [value]="2">Approved</mat-option>
                        <mat-option [value]="3">Obsolete</mat-option> -->

                        <ng-container matColumnDef="Actions">
                            <mat-header-cell *matHeaderCellDef class="print-ignore">Actions</mat-header-cell>
                            <mat-cell *matCellDef="let element; index as i;" class="print-ignore">
                                <tyl-mat-menu id="beActionMenu{{i}}" image="actions.png" [iconWidth]="30">
                                    <button id="editTest{{i}}" mat-menu-item class="menuItem"
                                        (click)="editTestClick(element)">
                                        Edit Test
                                    </button>
                                    <button id="viewTestSteps{{i}}" mat-menu-item class="menuItem"
                                        (click)="viewTestStepsClick(element)">
                                        View Steps
                                    </button>
                                    <button *ngIf="!element.IsSubTestOnly" id="showQuickView{{i}}" mat-menu-item
                                        class="menuItem" (click)="showQuickView(element)">
                                        Show Quick View
                                    </button>
                                    <button *ngIf="element.IsSubTestOnly" id="viewDependentTests{{i}}" mat-menu-item
                                        class="menuItem" (click)="viewDependentTests(element)">
                                        View Dependent Tests
                                    </button>
                                    <button id="copyTest{{i}}" mat-menu-item class="menuItem"
                                        (click)="copyTestClick(element)">
                                        Copy to New Test
                                    </button>
                                    <button id="deleteTest{{i}}" style="border-top: thin solid lightgray;" mat-menu-item
                                        class="menuItem" (click)="deleteTest(element)">
                                        Delete
                                    </button>
                                </tyl-mat-menu>
                            </mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true" id="BEHeader">
                        </mat-header-row>
                        <mat-row *matRowDef="let row; columns: columnsToDisplay; index as i;" id="beDataRow{{i}}"
                            [style.background-color]="getBackgroundColorForTest(row)" tabindex="0"
                            [ngStyle]="{'border-bottom-width':checkExpanded(row) ? '0px' : '1px'}"
                            style="padding:0px;overflow: hidden;" matRipple (click)="toggleExpanded(row)"
                            (keydown)="rowKeyPress($event, row)">
                        </mat-row>
                    </mat-table>
                </div>
            </div>
        </tyl-kendo-pdf-export>

    </div>
    <!-- <behavior-event-filter #behaviorEventFilter [showFilter]="showFilterEvent"
        [ngStyle]="{'display': showFilter ? 'flex' : 'none'}" [clearFilter]="clearFilterEvent"
        [incidentCodes]="incidentCodes" [actionCodes]="actionCodes" [locations]="locations"
        (closeFilterEvent)="showFilterClick()" class="filter-body">
    </behavior-event-filter> -->
</div>


<!-- <h2 mat-dialog-title *ngIf="showTests" translate style="margin: 0px">Automated Tests</h2>
<h2 mat-dialog-title *ngIf="showTestSteps" translate style="margin: 0px">{{test.TestName}} - Steps</h2> -->


<mat-dialog-content>

    <h2 mat-dialog-title *ngIf="showParameters" translate style="margin: 0px">Parameters - {{test.TestName}}</h2>
    <table class="table" style="width:100%;" *ngIf="showParameters">

        <tr>
            <td>Parameter Name</td>
            <td>Parameter Value</td>
            <td>Actions</td>
        </tr>
        <tr *ngFor="let thisParameter of parameters" style="border-top: 1px solid silver;">
            <td>{{thisParameter.ParameterName}}
                <!-- <textarea  matInput style = 'background-color:#fefefe; width: 100%; font-size: 8pt; line-height:normal; border:1px solid Silver;'
            [(ngModel)]="thisParameter.ParameterName" spellcheck="false"
            id="txtParameterNames{{$index}}"  name="txtParameterNames{{$index}}" rows="3" ></textarea> -->
            </td>
            <td>{{thisParameter.ParameterValue}}
                <!-- <textarea  matInput style = 'background-color:#fefefe; width: 100%; font-size: 8pt; line-height:normal; border:1px solid Silver;'
            [(ngModel)]="thisParameter.ParameterValue" spellcheck="false"
            id="txtParameterValues{{$index}}"  name="txtParameterValue{{$index}}" rows="3" ></textarea> -->
            </td>
            <tyl-mat-menu id="beParameterMenu" image="actions.png" [iconWidth]="30">
                <button id="editParameter" mat-menu-item class="menuItem" (click)="editParameterClick(thisParameter)">
                    Edit
                </button>
                <button id="deleteParameter" style="border-top: thin solid lightgray;" mat-menu-item class="menuItem"
                    (click)="deleteParameter(thisParameter)">
                    Delete
                </button>
            </tyl-mat-menu>


        </tr>
        <tr style="border-top: 1px solid silver;"></tr>
    </table>

    <!-- TEST STEPS -->
    <table class="table" *ngIf="showTestSteps">
        <tr>
            <td></td>
            <td>Page Name</td>
            <!--Area-->
            <td>Tab/View Name</td>
            <!--Sub Area-->
            <td>Object Name</td>
            <!--Element-->
            <td>Action</td>
            <td>Data Input</td>
            <td>Insert</td>
            <td style="padding-left: 7px;">Comments</td>
            <td>Delete</td>
        </tr>
        <tr *ngFor="let testStep of testSteps | orderBy: 'StepOrder'; index as i"
            [style.background-color]="getBackgroundColor(testStep)">
            <td style="width:25px;">
                #{{testStep.StepOrder}}
            </td>
            <!-- <mat-select id="ddlElements{{$index}}"  name="ddlElements{{$index}}" style="width: 225px; border:1px solid Silver;"
                        [(ngModel)]="testStep"

                >
                    <mat-option *ngFor="let item of elementListItems" [value]="testStep"
                    (ngModelChange)="getActions(item, testStep);"
                    (click) = "getActions(item, testStep)"
                    >
                        {{item.TextField}}
                    </mat-option>
                </mat-select> -->
            <td>


                <!-- <mat-select id="ddlElementAreas{{$index}}"  name="ddlElementAreas{{$index}}" style="width: 175px; border:1px solid Silver;"
                    [ngModel]="testStep.ElementAreaName"
                    (ngModelChange)="elementArea = $event;  elementAreaChanged(testStep);"  >
                    <mat-option *ngFor="let item of distinctAreas" [value]="item.AreaName" >
                        {{item.AreaName}}
                    </mat-option>
                </mat-select> -->

                <mat-select id="ddlElementAreas{{i}}" name="ddlElementAreas{{i}}"
                    style="width: 175px; border:1px solid Silver;" [ngModel]="testStep.ElementAreaName"
                    (ngModelChange)="testStep.ElementAreaName = $event;  elementAreaChanged(testStep);">
                    <mat-option *ngFor="let item of distinctAreas; index as i;" [value]="item.AreaName"
                        id="elementArea{{i}}">
                        {{item.AreaName}}
                        <!--Page Name-->
                    </mat-option>
                </mat-select>


            </td>
            <td>

                <mat-select id="ddlElementSubAreas{{i}}" name="ddlElementSubAreas{{i}}"
                    style="width: 175px; border:1px solid Silver;" [ngModel]="testStep.ElementSubAreaName"
                    (ngModelChange)="testStep.ElementSubAreaName = $event;  elementAreaChanged(testStep);">
                    <!--elementSubAreas-->
                    <mat-option *ngFor="let item of testStep.ElementSubAreas; index as i;" [value]="item"
                        id="elementSubArea{{i}}">
                        {{item}}
                        <!--Tab/View Name-->
                    </mat-option>
                </mat-select>
            </td>
            <td>
                <mat-select id="ddlElements{{i}}" name="ddlElements{{i}}" style="width: 175px; border:1px solid Silver;"
                    [(ngModel)]="testStep.ElementName">
                    <mat-option *ngFor="let item of testStep.Elements; index as i;" [value]="item.ElementName"
                        id="element{{i}}" (ngModelChange)="getActions(item, testStep);"
                        (click)="getActions(item, testStep)">
                        {{item.ElementName}}
                        <!--Object Name-->
                    </mat-option>
                </mat-select>
            </td>
            <td>

                <!-- <mat-select id="ddlActions{{$index}}"  name="ddlActions{{$index}}"  style="width: 175px; border:1px solid Silver;"
                        [ngModel]="testStep.ActionName"
                        (ngModelChange)="actionName = $event; actionClicked(testStep);"
                    >
                        <mat-option *ngFor="let item of testStep.Element.Actions" [value]="testStep.ActionName">
                            {{item}}
                        </mat-option>
                    </mat-select> -->
                <mat-select id="ddlActions" name="ddlActions" style="width: 175px; border:1px solid Silver;"
                    [(ngModel)]="testStep.ActionName">
                    <mat-option *ngFor="let item of testStep.Element.Actions" [value]="item"
                        (ngModelChange)="actionClicked(testStep, $event);" (click)="actionClicked(testStep, $event);">
                        {{item}}
                    </mat-option>
                </mat-select>
            </td>
            <td style='width:160px;'>
                <!-- <mat-select id="ddlParameters{{$index}}"  name="ddlParameters{{$index}}"  style="width: 175px; border:1px solid Silver;"
                [ngModel]="testStep.ParameterName"
            >
                <mat-option>
                    Student Number
                </mat-option>
                <mat-option>
                    User Name
                </mat-option>
                <mat-option>
                    Password
                </mat-option>
            </mat-select>      -->
                <textarea *ngIf="testStep.ActionName == 'Enter Text'
            || testStep.ActionName == 'Validate Value'
            || testStep.ActionName == 'Validate Value By Row Number'
            || (testStep.Element.ControlName == 'Table Cell' && testStep.ActionName == 'Click Cell')
            || (testStep.Element.ControlName == 'Sort Button' && testStep.ActionName == 'Click Sort Button By Column And Row')
            || testStep.ActionName == 'Click Cell By Row Number'
            || testStep.ActionName == 'Click Row Number'
            || testStep.ActionName == 'Select Combo Box Item'
            || testStep.ActionName == 'Select Combo Box Value'

            " matInput
                    style='background-color:#fefefe; width: 100%; font-size: 8pt; line-height:normal; border:1px solid Silver;'
                    [(ngModel)]="testStep.ParameterValue" spellcheck="false" id="txtParameters" name="txtParameters"
                    rows="3"></textarea>
                <!-- <input matInput style = 'background-color:#fefefe; width: 100%; font-size: 8pt; line-height:normal; border:1px solid Silver;'
            [(ngModel)]="testStep.ParameterValue"  > -->


            </td>
            <td style="padding-left: 7px;">
                <tyl-button style="float:right; color: rgb(35, 30, 30);" image="arrow_upward_black.png"
                    (clickEvent)="insertStep(testStep)"></tyl-button>
            </td>
            <td>
                <!-- <a (click)="showStepComment(testStep)">Comment</a> -->
                <textarea matInput style='width: 300px; font-size: 8pt; line-height:normal; border:1px solid Silver;'
                    [(ngModel)]="testStep.Comments" spellcheck="true" id="txtStepComments" name="txtStepComments"
                    rows="3"></textarea>
            </td>
            <td>
                <tyl-button style="float:right; color: rgb(35, 30, 30);" image="cancelnocircle.png"
                    (clickEvent)="deleteStep(testStep)"></tyl-button>
            </td>
            <!-- <ng-container matColumnDef="Actions">
                <mat-header-cell *matHeaderCellDef class="print-ignore">Actions</mat-header-cell>
                <mat-cell *matCellDef="let element; index as i;" class="print-ignore">
                    <tyl-mat-menu id="beActionMenu{{i}}" image="actions.png" [iconWidth]="30">
                        <button id="editTest{{i}}"
                            mat-menu-item class="menuItem" (click)="editTestClick(element)">
                            Edit
                        </button>
                        <button id="viewTestSteps{{i}}" mat-menu-item class="menuItem"
                            (click)="viewTestStepsClick(element)">
                            View Steps
                        </button>
                        <button id="deleteTest{{i}}" style="border-top: thin solid lightgray;"
                            mat-menu-item class="menuItem" (click)="deleteTest(element)">
                            Delete
                        </button>
                    </tyl-mat-menu>
                </mat-cell>
            </ng-container> -->

            <!-- <td>
                <input matInput  id="txtDataInput{{$index}}" name="txtDataInput{{$index}}"  style="width:350px; border:1px solid Silver;"
                    [ngModel]="dataInput" >
            </td> -->


        </tr>
        <!-- <tr>
            <tyl-button image="add.png" translate label="Add Step" (clickEvent)="addStep()"></tyl-button>
            <br>&nbsp;<br>
        </tr> -->
        <!-- <tr>
            <td colspan="3">
                <textarea matInput style = 'background-color:#fefefe; width: 100%; color: blue; font-size: 8pt; line-height:normal; border:1px solid Silver;'
                    [(ngModel)]="testText" spellcheck="false"
                    id="testText"  name="testText" rows="20" >

                </textarea>
            </td>
        </tr> -->
    </table>

</mat-dialog-content>


<!-- Dialog Footer -->
<mat-dialog-actions>
    <div class='flex-footer-left' style="align-items: center; width: 50%">
        <tyl-button *ngIf="showTestSteps" style="color: black;" image="previous arrow.png" label="Tests"
            (clickEvent)="showTestsClick();"></tyl-button>
        <tyl-button *ngIf="showParameters" style="color: black;" image="previous arrow.png" label="Test Steps"
            (clickEvent)="showParameterGrid(false)"></tyl-button>
        <tyl-button *ngIf="showTests" image="add.png" translate label="Add Test" (clickEvent)="addTest()"></tyl-button>
        <tyl-button *ngIf="showTestSteps" image="add.png" translate label="Add Step" (clickEvent)="addStep(false)">
        </tyl-button>
        <tyl-button *ngIf="showTestSteps" image="add.png" translate label="Add Shared Test"
            (clickEvent)="addStep(true)"></tyl-button>
        <tyl-button *ngIf="!showParameters" style="float:left; color: black;" image="Legend.png" label="Legend"
            (clickEvent)="legendClick()"></tyl-button>
        <tyl-button *ngIf="!showParameters && showTestSteps && !(test.IsSubTestOnly == true)" style="float:left;"
            image="listnocircle.png" label="Parameters" translate (clickEvent)="showParameterGrid(true)"></tyl-button>
        <tyl-button *ngIf="showParameters" image="add.png" translate label="Add Parameter"
            (clickEvent)="addParameter()"></tyl-button>
        <span style="padding-left: 8px;" *ngIf="!showParameters && showTestSteps && test.IsSubTestOnly">
            <i>Note: Parameter values must be set at main test level</i>
        </span>
        <tyl-button style="float:left;" image="listnocircle.png" label="Elements" translate
            (clickEvent)="showElementList()"></tyl-button>
        <tyl-button style="float:left;" image="listnocircle.png" label="Modules / Portals" translate
            (clickEvent)="showModulePortalList()"></tyl-button>
        <tyl-button style="float:left;" image="listnocircle.png" label="Pages & Tabs / Views" translate
            (clickEvent)="showPageTabList()"></tyl-button>
    </div>

    <!-- Center -->
    <div class="flex-footer-center" style="display: flex; align-items: center;">
        <filter-notification [filtered]="dataSource.isFiltered()" (clearFilter)="dataSource.removeAllFilters()">
        </filter-notification>
    </div>

    <div class='flex-footer-right' style="align-items: center; width: 50%">
        <tyl-button *ngIf="showTestSteps" image="save.png" translate label="Save" (clickEvent)="saveTestStepsClick()">
        </tyl-button>
        <tyl-button *ngIf="!showParameters && showTestSteps" image="cancel.png" translate label="Cancel"
            (clickEvent)="showTestsClick()"></tyl-button>
        <tyl-button *ngIf="showParameters" image="cancel.png" translate label="Cancel"
            (clickEvent)="showParameterGrid(false)"></tyl-button>
        <tyl-button *ngIf="!showParameters && !showTestSteps" image="cancel.png" translate label="Close"
            (clickEvent)="closeClick()"></tyl-button>
    </div>


</mat-dialog-actions>